export abstract class Loadable {
  protected abstract load(): void;
}
